'use strict';

var React = require('react'),
    Analytics = require('../utils/Analytics'),
    AnalyticsEvents = require('../constants/AnalyticsEvents'),
    Group = require('../organisms/Group'),
    Page = require('../organisms/Page'),
    Container = require('../organisms/Container'),
    EmptyState = require('../molecules/EmptyState'),
    UserInfo = require('../organisms/UserInfo'),
    UserActionCreators = require('../actions/UserActionCreators'),
    StampActionCreators = require('../actions/StampActionCreators'),
    ZineActionCreators = require('../actions/ZineActionCreators'),
    NavigationContextTypes = require('../constants/NavigationContextTypes'),
    UserStore = require('../stores/UserStore'),
    StampStore = require('../stores/StampStore'),
    ZineStore = require('../stores/ZineStore'),
    UserLatestStampStore = require('../stores/UserLatestStampStore'),
    UserLikedStampStore = require('../stores/UserLikedStampStore'),
    UserCuratedZineStore = require('../stores/UserCuratedZineStore'),
    ScreenSizeStore = require('../stores/ScreenSizeStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    ScrollStateMixin = require('../mixins/ScrollStateMixin'),
    Loader = require('../atoms/Loader'),
    DocumentTitle = require('../atoms/DocumentTitle'),
    OffsetMonitor = require('../atoms/OffsetMonitor'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    PageQueryMixin = require('../mixins/PageQueryMixin'),
    Button = require('../atoms/Button'),
    getStampCountPerRow = require('../utils/getStampCountPerRow'),
    PageControlsTypes = require('../constants/PageControlsTypes'),
    AppContext = require('../AppContext'),
    { isInitialPath, transitionTo } = require('../router'),
    { PropTypes } = React;

var LATEST_OR_CURATED_COLUMNS = 3,
    LIKED_COLUMNS = 4,
    DEFAULT_ROW_COUNT = 2,
    MIN_ITEM_COUNT = 6;

var UserPage = React.createClass({
  mixins: [
    ScrollStateMixin,
    PageQueryMixin,
    PureRenderMixin,
    createStoreMixin(
      UserStore,
      UserLatestStampStore,
      UserLikedStampStore,
      UserCuratedZineStore,
      StampStore,
      ZineStore,
      ScreenSizeStore
    )
  ],

  propTypes: {
    params: PropTypes.shape({
      userId: PropTypes.string.isRequired
    }).isRequired
  },

  parseUserId(props) {
    props = props || this.props;
    return parseInt(props.params.userId, 10);
  },

  getScrollState(scrollY) {
    return {
      isScrolled: scrollY > 52,
      hasScrolledPastPublished: this.hasScrolledPastOffset(this._publishedOffsetTop),
      hasScrolledPastCurated: this.hasScrolledPastOffset(this._curatedOffsetTop),
      hasScrolledPastLiked: this.hasScrolledPastOffset(this._likedOffsetTop)
    };
  },

  getStateFromStores(props) {
    var userId = this.parseUserId(props),
        screenSize = ScreenSizeStore.getScreenSize(),
        latestOrCuratedPerRow = getStampCountPerRow(screenSize, LATEST_OR_CURATED_COLUMNS),
        likedPerRow = getStampCountPerRow(screenSize, LIKED_COLUMNS),
        isContentReady;

    isContentReady =
      UserLatestStampStore.getPageCount(userId) > 0 &&
      UserLikedStampStore.getPageCount(userId) > 0 &&
      UserCuratedZineStore.getPageCount(userId) > 0;

    return {
      user: UserStore.get(userId),
      isMe: UserStore.isMe(userId),
      isContentReady: isContentReady,
      latestStamps: UserLatestStampStore.getStamps(userId),
      likedStamps: UserLikedStampStore.getStamps(userId),
      curatedZines: UserCuratedZineStore.getZines(userId),
      latestOrCuratedPerRow: latestOrCuratedPerRow,
      likedPerRow: likedPerRow
    };
  },

  getStampItemProps(stamp) {
    return {
      primaryZine: StampStore.getPrimaryZine(stamp.id)
    };
  },

  componentWillMount() {
    this.resetRecordedOffsets();
  },

  componentDidMount() {
    this.handleUserChange(this.props);
  },

  componentWillReceiveProps(nextProps) {
    if (this.parseUserId() !== this.parseUserId(nextProps)) {
      this.handleUserChange(nextProps);
      this.setState(this.getStateFromStores(nextProps));
      this.resetRecordedOffsets();
    }
  },

  resetRecordedOffsets() {
    this._publishedOffsetTop = 0;
    this._curatedOffsetTop = 0;
    this._likedOffsetTop = 0;
  },

  handleUserChange(props) {
    var userId = this.parseUserId(props);

    UserActionCreators.requestUser(userId, ['services']);
    StampActionCreators.requestUserLatestPage(userId, true, !isInitialPath());
    StampActionCreators.requestUserLikedPage(userId, true);
    ZineActionCreators.requestUserCuratedPage(userId, true);

    Analytics.trackEvent(AnalyticsEvents.USER_VIEW, {
      userId: userId
    });
  },

  getPageControls() {
    const userId = this.parseUserId(this.props);
    return [PageControlsTypes.USER, { userId }];
  },

  getNavigationContext() {
    const userId = this.parseUserId(this.props);
    const {
      isScrolled,
      hasScrolledPastPublished,
      hasScrolledPastCurated,
      hasScrolledPastLiked
    } = this.state;

    return [NavigationContextTypes.USER, {
      userId,
      isScrolled,
      hasScrolledPastPublished,
      hasScrolledPastCurated,
      hasScrolledPastLiked
    }];
  },

  getAppContext() {
    const [pageControlsType, pageControlsOptions] = this.getPageControls();
    const [navigationContextType, navigationContextOptions] = this.getNavigationContext();

    return {
      pageControlsType,
      pageControlsOptions,
      navigationContextType,
      navigationContextOptions
    };
  },

  render() {
    var user = this.state.user;

    return (
      <AppContext {...this.getAppContext()}>
        <DocumentTitle title={user && user.name}>
          <Page>
            {!user && this.renderLoader()}
            {user && this.renderInfo(user)}
            {user && this.renderContent()}
          </Page>
        </DocumentTitle>
      </AppContext>
    );
  },

  renderLoader() {
    return (
      <Container context='Page'>
        <Loader absoluteCenter />
      </Container>
    );
  },

  renderInfo(user) {
    return (
      <Container context='Page'
                 fillParent={false}>
        <UserInfo user={user}
                  context='Page'
                  size='large'
                  imageSize='xlarge'
                  vertical
                  noLink
                  showAbout
                  showLocation
                  showWebsite
                  showAccounts
                  showSubscribers
                  showSubscriptions />
      </Container>
    );
  },

  renderContent() {
    var userId = this.parseUserId();

    var {
      isContentReady,
      latestStamps,
      likedStamps,
      curatedZines,
      latestOrCuratedPerRow,
      likedPerRow
    } = this.state;

    if (!isContentReady) {
      return (
        <Container context='Page'>
          <Loader absoluteCenter />
        </Container>
      );
    }

    var hasLatest = latestStamps.length > 0,
        hasCurated = curatedZines.length > 0,
        hasLiked = likedStamps.length > 0,
        perLatestOrCuratedFirstPage = latestOrCuratedPerRow * DEFAULT_ROW_COUNT,
        perLikedFirstPage = likedPerRow * DEFAULT_ROW_COUNT;

    if (perLatestOrCuratedFirstPage < MIN_ITEM_COUNT) {
      perLatestOrCuratedFirstPage += latestOrCuratedPerRow;
    }

    if (perLikedFirstPage < MIN_ITEM_COUNT) {
      perLikedFirstPage += likedPerRow;
    }

    if (!hasLatest && !hasCurated && !hasLiked) {
      return this.renderEmptyState();
    }

    return [
      hasLatest && (
        <OffsetMonitor onOffsetTopChange={this.handlePublishedOffsetTopChange}
                       key='published'>
          <Container context='Page'>
            <Group title='Published Stamps'
                   type='stamps'
                   mode='grid'
                   context='page'
                   columns={LATEST_OR_CURATED_COLUMNS}
                   perFirstPage={perLatestOrCuratedFirstPage}
                   items={latestStamps}
                   itemProps={{
                     routeName: 'userLatestStamp',
                     routeParams: { userId: userId }
                   }}
                   getItemProps={this.getStampItemProps}
                   isExpectingPage={UserLatestStampStore.isExpectingPage(userId)}
                   isLastPage={UserLatestStampStore.isLastPage(userId)}
                   isInvalidated={UserLatestStampStore.isInvalidated(userId)}
                   loadNextPage={this.requestNextLatestPage}
                   defaultPage={this.parsePage(0)}
                   onPageChange={this.replacePage.bind(this, 0)} />
          </Container>
        </OffsetMonitor>
      ),

      hasCurated && (
        <OffsetMonitor onOffsetTopChange={this.handleCuratedOffsetTopChange}
                       key='curated'>
          <Container context='Page'>
            <Group title='Collections'
                   type='zines'
                   mode='grid'
                   context='page'
                   columns={LATEST_OR_CURATED_COLUMNS}
                   perFirstPage={perLatestOrCuratedFirstPage}
                   items={curatedZines}
                   isExpectingPage={UserCuratedZineStore.isExpectingPage(userId)}
                   isLastPage={UserCuratedZineStore.isLastPage(userId)}
                   isInvalidated={UserCuratedZineStore.isInvalidated(userId)}
                   loadNextPage={this.requestNextCuratedPage}
                   defaultPage={this.parsePage(1)}
                   onPageChange={this.replacePage.bind(this, 1)} />
          </Container>
        </OffsetMonitor>
      ),

      hasLiked && (
        <OffsetMonitor onOffsetTopChange={this.handleLikedOffsetTopChange}
                       key='liked'>
          <Container context='Page'>
            <Group title='Liked Stamps'
                   type='stamps'
                   mode='grid'
                   context='page'
                   columns={LIKED_COLUMNS}
                   perFirstPage={perLikedFirstPage}
                   // Avoid holes when on xl screens 4-column grid has 5 columns:
                   perPage={perLikedFirstPage % 5 === 0 ? 20 : 24}
                   items={likedStamps}
                   itemProps={{
                     size: 'small',
                     routeName: 'userLikedStamp',
                     routeParams: { userId: userId }
                   }}
                   getItemProps={this.getStampItemProps}
                   isExpectingPage={UserLikedStampStore.isExpectingPage(userId)}
                   isLastPage={UserLikedStampStore.isLastPage(userId)}
                   isInvalidated={UserLikedStampStore.isInvalidated(userId)}
                   loadNextPage={this.requestNextLikedPage}
                   defaultPage={this.parsePage(2)}
                   onPageChange={this.replacePage.bind(this, 2)} />
          </Container>
        </OffsetMonitor>
      )
    ];
  },

  renderEmptyState() {
    var { user, isMe } = this.state,
        actions;

    var label = isMe ?
      'Your liked, posted stamps and created collections will be shown here.' :
      `${user.name} has not liked, posted any stamps or created collections yet.`;

    if (isMe) {
      actions = (
        <div className='utils--hideOnTablet'>
          <Button onClick={this.handleCreateStampClick}>Create a Stamp</Button>
          <EmptyState.Separator>or</EmptyState.Separator>
          <Button onClick={this.handleCreateCollectionClick}>Create a Collection</Button>
        </div>
      );
    }

    return (
      <Container context='Page'>
        <EmptyState label={label}
                    absoluteCenter>
          {actions}
        </EmptyState>
      </Container>
    );
  },

  handlePublishedOffsetTopChange(publishedOffsetTop) {
    this._publishedOffsetTop = publishedOffsetTop;
    this.updateScrollState();
  },

  handleCuratedOffsetTopChange(curatedOffsetTop) {
    this._curatedOffsetTop = curatedOffsetTop;
    this.updateScrollState();
  },

  handleLikedOffsetTopChange(likedOffsetTop) {
    this._likedOffsetTop = likedOffsetTop;
    this.updateScrollState();
  },

  handleCreateStampClick() {
    transitionTo('draftCompose', { stampSegment: 'new' });
  },

  handleCreateCollectionClick() {
    transitionTo('zineNew');
  },

  requestNextLatestPage() {
    var userId = this.parseUserId();
    StampActionCreators.requestUserLatestPage(userId);
  },

  requestNextLikedPage() {
    var userId = this.parseUserId();
    StampActionCreators.requestUserLikedPage(userId);
  },

  requestNextCuratedPage() {
    var userId = this.parseUserId();
    ZineActionCreators.requestUserCuratedPage(userId);
  }
});

module.exports = UserPage;



/** WEBPACK FOOTER **
 ** ./pages/UserPage.jsx
 **/